/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { IDeliveryPageData } from './delivery-page.data';
import { IDeliveryPageProps } from './delivery-page.props.autogenerated';

export interface IDeliveryPageViewProps extends IDeliveryPageProps<IDeliveryPageData> {}

/**
 *
 * DeliveryPage component
 * @extends {React.PureComponent<IDeliveryPageProps<IDeliveryPageData>>}
 */
class DeliveryPage extends React.PureComponent<IDeliveryPageProps<IDeliveryPageData>> {
    public render(): JSX.Element | null {
        return this.props.renderView(this.props);
    }
}

export default DeliveryPage;
